module.exports = __webpack_public_path__ + "static/img/app.f11040a8.svg";